import React from 'react';
import Label from '../../../components/label/Label';
import { Controller, useFormContext } from 'react-hook-form';
import { ItemGroupsDropdown } from 'legacy/app/components/dropdowns/ItemGroupsDropdown';
import { TTypeOption } from 'legacy/app/components/dropdowns/types/TTypeOption';

interface IItemGroupSelect {
	projectCode: string;
	onCreateOption: (value: string) => void;
	onChange: (option: TTypeOption | null) => void;
	disabled: boolean;
	newOption: string | null;
}

const ItemGroupSelect = ({
	projectCode,
	onCreateOption,
	onChange,
	disabled,
	newOption,
}: IItemGroupSelect) => {
	const methods = useFormContext();
	return (
		<div className="tw-flex tw-flex-col xl:tw-flex-row tw-justify-center xl:tw-justify-start tw-col-span-2 tw-w-full lg:tw-col-span-1 tw-items-center !tw-gap-4">
			<Label label="Group" />
			<Controller
				control={methods.control}
				name="groupname"
				render={({ field }) => (
					<div className="tw-w-full">
						<ItemGroupsDropdown
							inputId="items-page-group-select"
							onCreateOption={onCreateOption}
							isDisabled={disabled}
							projectCode={projectCode}
							value={field.value}
							onChange={(event) => {
								onChange(event);
								field.onChange(event);
							}}
							newOption={newOption}
						/>
					</div>
				)}
			/>
		</div>
	);
};

ItemGroupSelect.displayName = 'ItemGroupSelect';

export { ItemGroupSelect };
